import React from 'react';
import { styled } from '@mui/material';
import { PrimaryButton, Text } from 'library';
import { IProviderPreferredWorker } from '../models';

export function PreferredButton({
    preferredAll,
    preferredLocations,
    setOpenPreferredModal,
}: {
    preferredAll: boolean;
    preferredLocations: IProviderPreferredWorker[];
    setOpenPreferredModal: (open: boolean) => void;
}) {
    return (
        <ButtonContainer>
            <PrimaryButton
                buttonStyle={{
                    width: 'fit-content',
                    marginLeft: 10,
                    marginTop: 10,
                }}
                onClick={() => setOpenPreferredModal(true)}
            >
                Add as a Preferred Worker
            </PrimaryButton>
            <Text variant="caption">
                Currently a Preferred Worker at {preferredAll ? 'all' : preferredLocations?.length ?? 0} locations{' '}
            </Text>
        </ButtonContainer>
    );
}

const ButtonContainer = styled('div')({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
});
